import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  private configPadraoSucesso: MatSnackBarConfig = {
    duration: 2000,
    verticalPosition: 'top',
    horizontalPosition: 'end',
    panelClass: ['snackbar', 'green-snackbar'],
  };

  private configPadraoErro: MatSnackBarConfig = {
    verticalPosition: 'top',
    horizontalPosition: 'end',
    panelClass: ['snackbar', 'red-snackbar'],
  };

  private configPadraoAlerta: MatSnackBarConfig = {
    duration: 5000,
    verticalPosition: 'top',
    horizontalPosition: 'end',
    panelClass: ['snackbar', 'yellow-snackbar'],
  };

  public constructor(private snackBar: MatSnackBar) {
    
  }

  public exibirSucesso(mensagem: string, acao: string = 'Ok', config: MatSnackBarConfig = this.configPadraoSucesso) {
    this.snackBar.open(mensagem, acao, config);
  }

  public exibirErro(mensagem: string, acao: string = 'Ok', config: MatSnackBarConfig = this.configPadraoErro) {
    this.snackBar.open(mensagem, acao, config);
  }

  public exibirAlerta(mensagem: string, acao: string = 'Ok', config: MatSnackBarConfig = this.configPadraoAlerta) {
    this.snackBar.open(mensagem, acao, config);
  }

}
